import { useQueryGetTipSettings } from '@src/pages/Couriers/queries';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import { getCurrentPageUrl, isPWA } from '@src/shared/utils';
import { TRACKING_DEFAULTS } from '@src/tracking/constant';
import { useAnalyticsHook } from '@src/tracking/hooks/use-analytics';
import { useEffect, useState } from 'react';
import i18n, { defaultLang } from '@src/i18n';

const useDashboardAnalytics = () => {
  const [pageViewTriggered, setPageViewTriggered] = useState(true);
  const tipSettings = useQueryGetTipSettings({});
  const { getConsentData, trackPage } = useAnalyticsHook();
  const { restaurant } = useKeycloakUserState();
  const [lastPath, setLastPath] = useState('');
  useEffect(() => {
    if (location.pathname !== lastPath) {
      tipSettings.remove();
      setPageViewTriggered(false);
      setLastPath(location.pathname);
    }
  }, [location.pathname]);

  useEffect(() => {
    const isLocationPermitted = !!(
      location.pathname === '/couriers' ||
      location.pathname === '/deliveries'
    );

    const tipDataReceived = !!(
      typeof tipSettings?.data?.showTips === 'boolean'
    );

    const getPageGroup = () => {
      if (
        location.pathname === '/deliveries'
      ) {
        return TRACKING_DEFAULTS.PAGES_GROUP.DELIVERY;
      } else if (location.pathname === '/couriers') {
        return TRACKING_DEFAULTS.PAGES_GROUP.COURIER;
      } else {
        return '';
      }
    };

    if (
      isLocationPermitted &&
      tipDataReceived &&
      getConsentData() &&
      restaurant &&
      !pageViewTriggered
    ) {
      trackPage(TRACKING_DEFAULTS.PAGES_TYPE.DEFAULT, {
        cookieConsent: getConsentData() || '',
        pageGroup: getPageGroup(),
        siteType: TRACKING_DEFAULTS.SITETYPE,
        url: getCurrentPageUrl(),
        tipsVisible: tipSettings?.data?.showTips,
        country: restaurant?.country as string,
        language: i18n.language || defaultLang,
        restaurantId: restaurant?.id || '',
        experiment_details: `CA1470 ${true}`,
        pagePWA: JSON.stringify(isPWA()),
      });
      setPageViewTriggered(true);
    }
  }, [tipSettings, getConsentData(), restaurant]);
};

export default useDashboardAnalytics;
